export default "__VITE_ASSET__CvVK8D7H__"